const TEAM_LEAVE_NOTIFICATION_TYPES = new Set([
  "leave_submitted",
  "leave_document_uploaded",
  "leave_cancelled",
]);

const MY_LEAVE_DETAIL_NOTIFICATION_TYPES = new Set([
  "leave_approved",
  "leave_rejected",
]);

export function getTimeOffNotificationPath(
  notifType: string,
  entityId: number | null,
  canAccessTeamLeave: boolean,
): string {
  if (notifType === "leave_replacement") {
    return "/leave";
  }

  if (TEAM_LEAVE_NOTIFICATION_TYPES.has(notifType) && canAccessTeamLeave) {
    const params = new URLSearchParams({ tab: "requests" });
    if (entityId != null) params.set("openRequest", String(entityId));
    return `/team-leave?${params.toString()}`;
  }

  if (MY_LEAVE_DETAIL_NOTIFICATION_TYPES.has(notifType) && entityId != null) {
    return `/leave?openRequest=${entityId}`;
  }

  return "/leave";
}
